import React, {useState} from "react";
import PropTypes from "prop-types";
import Auth0DetailsForm from "./Auth0DetailForm";
import CustomerComparisonTable from "./CustomerComparisonTable";
import CustomerDataTab from "../customerManager/customerDataTab";
import ReportModal from "./ReportModal";

const headingStyle = {
    fontFamily: "A Love of Thunder",
    color: "#007935",
    marginBottom: "10px"
};

const ExploreModal = ({lookUpResponse, onClose}) => (
    <div className="modal-overlay">
        <div className="modal-box">
            <div className="modal-title">
                <h2 id="explore-modal-title">Explore</h2>
                <button type="button"
                        className="close-btn"
                        onClick={onClose}
                        aria-label="Close Explore modal">
                    ✕
                </button>
            </div>

            <CustomerDataTab lookupData={lookUpResponse}/>
        </div>
    </div>
);

ExploreModal.propTypes = {
    lookUpResponse: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

const DetailsTab = ({lookUpResponse, user, auth0Details, showAlert, handleUpdateWynshopLoyaltyId}) => {
    const [showExploreModal, setShowExploreModal] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);

    return (
        <>
            <h4 id="sub_head" style={headingStyle}>Customer Details by Sources</h4>

            <CustomerComparisonTable lookUpResponse={lookUpResponse}
                                     handleUpdateWynshopLoyaltyId={handleUpdateWynshopLoyaltyId}/>

            <div className="explore-btn-container" style={{gap: "10px"}}>
                <button type="button" className="report-btn" onClick={() => setShowReportModal(true)}>
                    Report
                </button>
                <button type="button" className="explore-btn" onClick={() => setShowExploreModal(true)}>
                    Explore
                </button>
            </div>

            {showExploreModal && (
                <ExploreModal lookUpResponse={lookUpResponse} onClose={() => setShowExploreModal(false)}/>
            )}

            <ReportModal show={showReportModal}
                         onClose={() => setShowReportModal(false)}
                         user={user}
                         loyaltyId={lookUpResponse?.meta?.wynshopCustomer?.loyaltyId}
                         showAlert={showAlert}/>

            <Auth0DetailsForm auth0Details={auth0Details} fullWidth/>
        </>
    );
};

DetailsTab.propTypes = {
    lookUpResponse: PropTypes.object.isRequired,
    user: PropTypes.object,
    auth0Details: PropTypes.object,
    showAlert: PropTypes.func.isRequired,
    handleUpdateWynshopLoyaltyId: PropTypes.func.isRequired
};

DetailsTab.defaultProps = {
    user: null,
    auth0Details: null
};

export default DetailsTab;
